<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: 13113306050 13113306050@163.com
 * @LastEditTime: 2026-04-20 17:43:14
-->
<template>
  <div class="page page-game">
    <div style="margin-top:20px">
      <!-- <img src="/banner.jpg" alt="" style="width: 100%" /> -->
      <img src="https://apk.lxld668.com/img2/gggdir/gm2/1/1.jpg" alt="" style="width: 100%" />
    </div>
    <!-- <h2 class="title">游戏介绍</h2>
    <p>《幻灵格斗》是一款全新火影忍者题材策略卡牌手游，深度还原原著经典剧情与热血瞬间，让你沉浸式重返忍者世界；战斗中可畅爽释放标志性忍术大招，炫酷特效高度还原，带来极致视觉体验；游戏以放置挂机为核心玩法，轻松养成不肝不累，同时融合策略卡牌的收集与阵容搭配，多样组合与战术博弈让战场瞬息万变，助你打造最强忍者小队，开启属于你的忍界征程！</p> -->
    <!-- <h2 class="title" style="margin-bottom: 0px">游戏特色</h2> -->
     <h2 class="title">游戏介绍</h2>
    <p>欢迎来到《异界格斗》，握紧你的剑，与恶鬼展开决战！这个世界，正等待你的拯救。</p> 
    <div class="content">
      <div class="content-item">
        <h4>【昼夜锻刀，斩尽世间恶鬼】</h4>
        时间？从来不是阻碍！离线挂机，呼吸法自行运转，你的刀锋无时无刻不在变强。上线即收成，经验狂飙，战力爆表！斩鬼之路，唯快不破！
        <img src="https://apk.lxld668.com/img2/gggdir/gm2/1/2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【无限招募，集结传奇之柱】</h4>
        缘分未到？不，是机会不够！完成初始试炼，即赠上万次招募契机。风炎雷岩，呼吸法大师齐聚于此。组建你的全明星战队，缔造鬼杀队史上的不败传说！
        <img src="https://apk.lxld668.com/img2/gggdir/gm2/1/3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【协同血战，破晓无限城】</h4>
        直面潮水般的恶鬼，在“无限城”深处挑战十二鬼月！唯有完美配合，才能激发合击秘剑，斩破无尽黑暗。真正的荣耀，属于并肩作战的团队！
        <img src="https://apk.lxld668.com/img2/gggdir/gm2/1/4.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【登顶巅峰，铸就无双传奇】</h4>
        从无名队员到最强柱级，你的每一份功绩都将铭刻于排行榜之巅。召集最强剑士，制定终极战略，成为让整个鬼杀队仰望的传说。最强的剑，由你执掌！
勇者们，拔剑吧——恶鬼斩尽之日，即是光明重现之时！
        <img src="https://apk.lxld668.com/img2/gggdir/gm2/1/5.jpg" alt="" />
      </div>
    </div>

    <!-- <div class="content">
      <div class="content-item">
        <h4>【墙外调查 史诗重启】</h4>
        托洛斯特区攻防战、女巨人捕获作战、厄特加尔城死守、玛利亚之墙夺还战、地下室揭秘、马莱奇袭，所有经典战役由你亲历！剧情多线分支，你的每一个抉择都将影响同伴的生死与故事的结局走向！
        <img src="/1.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【兵团英姿 自由编成】</h4>
        特色时装系统还原角色经典与高光时刻，登录即送千抽，十连必出SSR，调查兵团、宪兵团、驻屯兵团精英任你招募！资源无损重置，角色自由重生，策略搭配阵容，应对每一次墙外巨人的威胁！
        <img src="/2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【立体机动 巅峰对决】</h4>
        完美还原立体机动装置的流畅与刺激，高速穿梭于战场，瞄准巨人后颈，一击必杀！全视角3D战斗，刀光剑影特效拉满，原版CV倾情献声，搭配泽野弘之的经典BGM，每一场战斗都如同动画原片般燃爆！
        <img src="/3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【兵团生活 惊喜不断】</h4>
        调查兵团总部，温馨宿舍与训练场，日常任务中隐藏着无数秘密与彩蛋。活动玩法多样，新服开启不断，跨服兵团战、壁外竞速赛常驻，与全服玩家共筑人类最后的希望！海量福利放送，零氪也能成为人类最强的士兵！
        <img src="/4.jpg" alt="" />
      </div>
    </div> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: top;
}
.content-item img {
  display: block;
  margin-top: 12px;
  width: 400px;
}
@media screen and (max-width: 768px) {
  .content-item {
    width: 100%;
  }
  .content-item img {
    width: 100%;
  }
}
</style>
